/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';

import { Graphql } from '@common/graphql';
import { SWITCH_ROLE } from '../../api/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { toHeaderCase } from 'js-convert-case';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { AppNavigatorService } from '@/AppNavigator';

export interface IGetAccessTokenMethods extends IPluginMethodMap {
  getAccessToken(args: any): Promise<any>;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export class GetAccessTokenService implements IAgentPlugin {
  readonly methods: IGetAccessTokenMethods;

  constructor() {
    this.methods = {
      getAccessToken: this.getAccessToken.bind(this),
    };
  }

  async getAccessToken(args: any) {
    let gql = Graphql.withBaseUrl(apiConfig?.gql?.url);
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();

    const storageSrv = StorageModule.getInstance();
    console.log('data in query', args);
    try {
      if (client) {
        console.log(client);
        const res = await client.query(SWITCH_ROLE, { ...args }).toPromise();
        console.log('profileress->', res, token);
        if (res?.data?.switchRole) {
          return res?.data?.switchRole;
        }

        throw res?.data?.errors?.[0];
      }
    } catch (err: any) {
      throw err;
    }
  }
}
